function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.994,12.469 L8.447,9.753 L3.478,12.469 L8.943,6.666 L11.553,9.383 L16.46,6.666 L10.994,12.469 Z M10,0 C4.477,0 0,4.478 0,10 C0,15.523 4.477,20 10,20 C15.522,20 20,15.523 20,10 C20,4.478 15.522,0 10,0 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/messenger.258294f8.svg";
export { SvgComponent as ReactComponent };